import classNames from "classnames";
import { useBEMClasses } from "@circle-react/hooks/utils/useBEMClasses";

export interface AvatarProps {
  [key: string]: unknown;
  isFullRounded?: boolean;
  lg?: boolean;
  sm?: boolean;
}

export const Avatar = (props: AvatarProps) => {
  const blockElement = "skeleton-loader__avatar";
  const { modifiers } = useBEMClasses(blockElement, props);
  const { isFullRounded = true } = props;

  return (
    <div className={classNames(blockElement, modifiers)}>
      <div
        className={classNames(
          "skeleton-loader__avatar-content !bg-tertiary",
          isFullRounded ? "!rounded-full" : "!rounded-md",
        )}
      />
    </div>
  );
};
